import { render } from "./FullscreenContainer.vue?vue&type=template&id=51f5b393&scoped=true"
import script from "./FullscreenContainer.vue?vue&type=script&lang=js"
export * from "./FullscreenContainer.vue?vue&type=script&lang=js"

import "./FullscreenContainer.vue?vue&type=style&index=0&id=51f5b393&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f5b393"]])

export default __exports__